import emojiDataEn from 'emoji-picker-react/dist/data/emojis-en';
import emojiDataEs from 'emoji-picker-react/dist/data/emojis-es';
import emojiDataPl from 'emoji-picker-react/dist/data/emojis-pl';
import emojiDataRu from 'emoji-picker-react/dist/data/emojis-ru';
import {EmojiData} from 'emoji-picker-react/dist/types/exposedTypes';

import {LocaleNameEnum} from '../../../../provider/locale/locale-context-type';

const EMOJI_PICKER_WIDTH = 320;
const EMOJI_PICKER_HEIGHT = 360;

const emojiDataByLocaleName: Record<LocaleNameEnum, EmojiData> = {
    [LocaleNameEnum.bgBg]: emojiDataEn,
    [LocaleNameEnum.enUs]: emojiDataEn,
    [LocaleNameEnum.esEs]: emojiDataEs,
    [LocaleNameEnum.kkKz]: emojiDataEn,
    [LocaleNameEnum.plPl]: emojiDataPl,
    [LocaleNameEnum.ruRu]: emojiDataRu,
};

export function getEmojiPickerDataByLocale(localeName: LocaleNameEnum): EmojiData {
    return emojiDataByLocaleName[localeName] ?? emojiDataEn;
}

export {EMOJI_PICKER_HEIGHT, EMOJI_PICKER_WIDTH};
